const SET_COLUMNS = (state, data) => {
  state.columns = data
}

const PUSH = (state, data) => {
  state.columns.push(data)
}

const RESET = (state) => {
  state.columns = []
}

const UPDATE = (state, data) => {
  const column = state.columns.find(x => x.id === data.id)

  column.name = data.name
  column.tabname = data.tabname
  column.type_id = data.type_id
}

export default {
  PUSH,
  RESET,
  UPDATE,
  SET_COLUMNS
}
